import { LinkType } from '~/db_types/swagger_types';
export const LinkTypeDisplay = new Map([
    [LinkType.COSMIC, 'System'],
    [LinkType.DOCUMENT, 'Document'],
    [LinkType.EDCC, 'EDCC'],
    [LinkType.EDS, 'EDS'],
    [LinkType.GIDEP, 'GIDEP'],
    [LinkType.NANADARTS, 'NANADARTS'],
    [LinkType.NMIS, 'NMIS'],
    [LinkType.OTHER, 'Other'],
    [LinkType.QARC, 'QARC'],
    [LinkType.RIDS, 'RIDs']
]);
